export const paramsForBackend = (_state, _getters, rootState, rootGetters) =>
  rootState.metrics.program.selectedPeriod && {
    loyalty_program_identifiers: [
      rootState.metrics.program.currentProgramIdentifier
    ],
    start_date: rootGetters['metrics/program/selectedPeriodStartDateFormatted'],
    end_date: rootGetters['metrics/program/selectedPeriodEndDateFormatted'],
    partner_ids: rootState.metrics.program.partners.map((p) => p.id)
  }
